export default {
    workflows: {
        title: "Flujos de Trabajo",
        description: "Gestiona flujos de trabajo personalizados para agentes de IA",
        newWorkflow: "Nuevo Flujo de Trabajo",
        searchPlaceholder: "Buscar por nombre...",
        statusPlaceholder: "Filtrar por estado",
        type: {
            default: "Predeterminado",
            custom: "Personalizado",
        },
        status: {
            active: "Activo",
            inactive: "Inactivo",
            draft: "Borrador",
        },
        headers: {
            name: "Nombre",
            type: "Tipo",
            status: "Estado",
            nodesCount: "Nodos",
            createdAt: "Creado",
            actions: "Acciones",
        },
        actions: {
            view: "Ver",
            edit: "Editar",
            delete: "Eliminar",
        },
        detail: {
            back: "Atrás",
            edit: "Editar",
            nodesCount: "Nodos",
            edgesCount: "Conexiones",
            createdAt: "Creado el",
            visualization: "Visualización del Flujo de Trabajo",
        },
        notFound: {
            title: "Flujo de Trabajo No Encontrado",
            message: "El flujo de trabajo solicitado no existe.",
            backToList: "Volver a la Lista",
        },
        noData: {
            title: "Sin Flujos de Trabajo",
            message: "Crea tu primer flujo de trabajo para comenzar.",
        },
        modal: {
            confirmDelete: "Eliminar Flujo de Trabajo",
            confirmDeleteMessage: "¿Estás seguro de que deseas eliminar este flujo de trabajo? Esta acción no se puede deshacer.",
        },
        new: {
            title: "Nuevo Flujo de Trabajo",
        },
        edit: {
            title: "Editar Flujo de Trabajo",
        },
        editor: {
            addNode: "Añadir Nodo",
            deleteNode: "Eliminar Nodo",
            cancel: "Cancelar",
            save: "Guardar",
            nodeProperties: "Propiedades del Nodo",
            nodeType: "Tipo",
            nodeLabel: "Etiqueta",
            agentType: "Tipo de Agente",
            actionType: "Tipo de Acción",
            condition: "Condición",
            nodeTypes: {
                start: "Nodo Inicio",
                agent: "Nodo Agente",
                decision: "Nodo Decisión",
                action: "Nodo Acción",
                end: "Nodo Fin",
            },
            defaultLabels: {
                start: "Inicio",
                agent: "Agente",
                decision: "Decisión",
                action: "Acción",
                end: "Fin",
            },
            agentTypes: {
                postino: "Correo/Cartero",
                classificatore: "Clasificador",
                parser: "Analizador",
                validatore: "Validador",
            },
            actionTypes: {
                notification_in_app: "Notificación In-App",
                notification_email: "Notificación Email",
                notification_both: "Notificación Completa",
            },
            operators: {
                equals: "Igual",
                contains: "Contiene",
                exists: "Existe",
                not_equals: "No Igual",
                not_contains: "No Contiene",
            },
            savingWorkflow: "Guardando flujo de trabajo...",
            workflowSaved: "¡Flujo de trabajo guardado con éxito!",
            relatedAccounts: "Cuentas Relacionadas",
            searchAccounts: "Buscar cuentas por nombre, email o NIF...",
            noAccountsFound: "No se encontraron cuentas",
            taxId: "NIF",
            selectedCount: "{{count}} seleccionadas",
            close: "Cerrar",
        },
        savingChanges: "Guardando cambios...",
        allSaved: "¡Todo guardado!",
    },
};
